import { render, staticRenderFns } from "./FurnitureCardMobile.vue?vue&type=template&id=0f02ba73&scoped=true&"
import script from "./FurnitureCardMobile.vue?vue&type=script&lang=js&"
export * from "./FurnitureCardMobile.vue?vue&type=script&lang=js&"
import style0 from "./FurnitureCardMobile.vue?vue&type=style&index=0&id=0f02ba73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f02ba73",
  null
  
)

export default component.exports